import { NavigationItem } from './NavigationItem';
import { classNames } from '~/utils/classNames';
import { getNavItemsMeta } from '~/utils/homepage-navbar-links';

export const Navbar = ({ className }: { className?: string }) => {
  const navigationItems = getNavItemsMeta();

  return (
    <nav className={classNames('h-full grow-1 shrink-0 justify-center', className)}>
      <ul className="flex flex-row gap-3 h-full">
        {navigationItems.map((item, index) => (
          <li key={index} className="h-full">
            <NavigationItem
              item={item}
              className={classNames(
                'h-full flex text-sm items-center px-1 bg-transparent text-bolt-ds-textSecondary [&:hover:where(:not(:disabled))]:text-bolt-ds-textPrimary lg:px-2.5',
                item.type === 'link' ? 'no-underline font-medium hover:text-bolt-ds-textPrimary' : '',
              )}
            />
          </li>
        ))}
      </ul>
    </nav>
  );
};
